import React from 'react'
import PropTypes from 'prop-types'

import { Button, Col, FormGroup, FormInput, FormSelect, Row } from 'shards-react'
import { ORG_TYPES } from '../../../../../constants/const'

const CovidReportForm = ({ orgList, onSubmit, setFormData, formData }) => {
  const handleInputChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  return (
    <Row className={'my-3 justify-content-between'}>
      <Col md={'auto'} className={'d-flex align-items-center'}>
        <FormGroup className={'mr-3'}>
          <label htmlFor='_to'>Дата</label>
          <FormInput size='sm' type={'date'} name={'date'} className='mb-2' value={formData.date} onChange={handleInputChange} />
        </FormGroup>
        <FormGroup className={'mr-3'}>
          <label htmlFor='_idOrg'>Выберите организацию</label>
          <FormSelect
            name={'idOrg'}
            id='_idOrg'
            size='sm'
            className='mb-2 d-block'
            onChange={handleInputChange}
            style={{ width: 730 }}
          >
            <option value={0}>Все организации</option>
            {orgList &&
              orgList.map(item => (
                <option key={item.idOrganization} value={item.idOrganization}>
                  {item.orgName}
                </option>
              ))}
          </FormSelect>
        </FormGroup>
        {formData.idOrg === '0' && (
          <FormGroup className={'mr-3'}>
            <label htmlFor='_school'>Тип ОО</label>
            <FormSelect
              name='school'
              id='_school'
              size='sm'
              className='mb-2 d-block'
              onChange={handleInputChange}
              value={formData.school}
            >
              {ORG_TYPES.map(({name, value}) => <option key={value} value={value}>{name}</option>)}
            </FormSelect>
          </FormGroup>
        )}
        <Button onClick={onSubmit}>Создать отчет</Button>
      </Col>
    </Row>
  )
}

CovidReportForm.propTypes = {
  orgList: PropTypes.array,
  onSubmit: PropTypes.func,
}

export default CovidReportForm
